import React, { FC } from 'react'
import { Layout } from 'components/Layout'
import { SettingsConfirmTemplate } from 'components/Templates'

const SettingsConfirm: FC = () => {
  return (
    <Layout title={'確認 | 営業時間・定休日の修正'}>
      <SettingsConfirmTemplate page={'regular'} />
    </Layout>
  )
}

export default SettingsConfirm
